import React from 'react'
import { graphql } from 'gatsby'
import SEO from '../components/SEO'
import BlogHero from '../components/blog/BlogHero'
import BlogPosts from '../components/blog/BlogPosts'

const Blog = ({
  location,
  data: {
    allContentfulBlogPost,
    contentfulBlogPage: {
      seoTitle,
      seoDescription,
      whiteTitle,
      featuredBlogpostImage,
      featuredBlogpost,
      blogPosts,
    },
  },
}) => {
  return (
    <>
      <SEO
        isBlog
        title={seoTitle}
        description={seoDescription}
        image={featuredBlogpostImage.file.url}
        location={location}
        pageCategory='Blog'
        referrer={location.state?.referrer}
      />
      <BlogHero
        featuredBlogpostImage={featuredBlogpostImage}
        featuredBlogpost={featuredBlogpost}
        whiteTitle={whiteTitle}
        location={location}
      />
      <BlogPosts
        contentfulBlogPosts={allContentfulBlogPost}
        selectedBlogPosts={blogPosts}
        location={location}
      />
    </>
  )
}

export const BlogQuery = graphql`
  query Blog($id: String!, $node_locale: String!) {
    contentfulBlogPage(id: { eq: $id }) {
      seoTitle
      seoDescription
      whiteTitle
      featuredBlogpostImage {
        file {
          url
        }
        fluid(sizes: "(max-width: 100vw) 100vw, 100vw") {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      featuredBlogpost {
        name
        slug
        seoTitle
        seoDescription
        title
        date
        type
        image {
          file {
            url
          }
          fluid(sizes: "(max-width: 100vw) 100vw, 100vw") {
            ...GatsbyContentfulFluid_withWebp_noBase64
          }
        }
        content {
          raw
          references {
            ... on ContentfulAsset {
              __typename
              contentful_id
              file {
                url
              }
              title
            }
            ... on ContentfulVideo {
              contentful_id
              poster {
                file {
                  url
                }
              }
              videoWebm {
                file {
                  url
                }
              }
              videoMp4 {
                file {
                  url
                }
              }
            }
          }
        }
      }
      blogPosts {
        availableInCountry
        id
        title
        image {
          title
          fluid(sizes: "(max-width: 1023px) 44vw, 25vw") {
            ...GatsbyContentfulFluid_withWebp_noBase64
          }
        }
        slug
        type
      }
    }
    allContentfulBlogPost(filter: { node_locale: { eq: $node_locale } }) {
      nodes {
        availableInCountry
        id
        slug
        title
        type
        image {
          title
          fluid(sizes: "(max-width: 1023px) 44vw, 25vw") {
            ...GatsbyContentfulFluid_withWebp_noBase64
          }
        }
      }
    }
  }
`

export default Blog
